var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parking-position"},[_c('van-button',{attrs:{"type":"info","size":"large"},on:{"click":_vm.toShowMediaPageFn}},[_vm._v(_vm._s(_vm.mediaType===9?'查看停车照片':'查看停车视频'))]),_c('div',{attrs:{"id":"mapParking"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }